module.exports = __webpack_public_path__ + "static/media/30-6.41b745b5.mp3";